export const patientsEn = {
  "Consultations": "Consultations",
  "Patients En cours": "Patients Ongoing",
  "Patients Terminé": "Patients Finish",

  "DOSS.NO": "DOSS.NO",
  "WhatsApp": "WhatsApp",
  "Balance": "Balance",
  "Chercher par Doss.NO": "Search by Reg.No",
  "Chercher par nom": "Search by name",
  "Chercher par numero telephone": "Search by phone number",
  "Non Archivé": "Not Archived",
  "Archivé": "Archived",
  "Patients": "Patients",
  "Patients en commun": "Shared patients",
  "Débiteur": "Debtor",
  "Régulariser": "Regularize",
  "Créancier": "Creditor",

  "Nom du patient": "Patient Name",
  "Numero de telephone": "Phone number",
  "Address du patient": "Patient address",
  "Address": "Address",
  "Année de naissance": "year of birth",
  "Etat de Santé": "Health condition",


  "Ajouter": "Add",
  "Modifier": "Modify",
  "Supprimer": "Delete",
  "Passer": "Pass",
  "Retourner": "Return",
  "Terminer": "Finish",
  "Envoyer": "Send",
  "Fermer": "Close",
  "Prise en charge": "Supported",

  "Assuré": "Assured",
  "Matricule Professionel": "Professional Number",
  "Pourcentage couvré par la societé": "Percentage covered by the company",


  /** START DEVIS  */
  "Traitement": "Treatment",
  "Dents": "Teeth",
  "Surface": "Surface",
  "NBS": "NBS",
  "Prix.U": "Unit price",
  "Total": "Total",
  "Reduction": "Reduction",
  "Reste": "Rest",

  "Ajouter un traitment pour creer un devis": "Add a treatment to create a quote",
  "Actions": "Actions",

  "Nom du traitement": "Treatment name",
  "Choisir les traitments du cabinet": "Choose the office’s treatments",
  "Donner la reduction en pourcent": "Give the reduction in percent",
  "Qty": "Qty",
  "Dents Pediatre": "Children's teeth",

  /** END DEVIS  */

  /** START Fiche  */

  "Date": "Date",
  "Actes": "Acts",
  "Montant": "Amount",
  "Facture": "Invoice",
  "RDV": "Appointement",

  /** END Fiche  */


  /** START INvoices */

  "global": "overall",
  "cabinet": "office",

  "Payé par l'Assurance": "Paid by insurance",
  "Payé par le patient": "Paid by the patient",

  /** END INvoices */

  "Laboratoire": "Laboratory",
  "Mode de paiement": "Payment method",
  "Status": "Status",
  "Reste du devis": "Rest of devis",
  "Age": "Age",

  /** START Bar navigation of manage patient **/

  "Devis": "Devis",
  "Factures": "Invoices",
  "Labo": "Labo",
  "Paiements": "Payments",
  "Pay Assuré": "Pay Insured",
  "Soins": "Care",
  "Fiches": "Sheets",
  "Fiche": "Sheet",

  /** END Bar navigation of manage patient **/



  // Server Side 
  "Donner une reduction valide": "Give a valid discount",
  "Le traitement a ete fait vous ne pouvez plus le supprimer.": "This treatment has already worked, and you can no longer delete them.",
  "la dernière facture n'est pas encore clôturé": "the last invoice is not yet closed",
  "La facture ne peut pas être supprimée car elle est déjà remplie": "The invoice cannot be deleted because it is already filled",

  "Le doctor est obligatoire.": "The doctor is required",
  "Le nom du patient est obligatoire.": "The patient's name is required.",
  "Le telephone du patient est obligatoire.": "The patient's phone number is required.",
  "Année de naissance du patient est obligatoire.": "Patient's year of birth is required.",
  "Choisir societe d'assurance.": "Choose insurance company.",
  "Donner le matricule.": "Give the registration number.",
  "Donner la prise en charge.": "Give support.",
  "Donner le pourcentage.": "Give the percentage.",

  "Donner le montant": "Give the amount",
  "Le patient est assuré par une societe que vous n'avez pas encore creer sa facture": "The patient is insured by a company that you have not yet created their invoice for",
  "Veuillez creer une facture pour cette societe d'assurance": "Please create an invoice for this insurance company",
  



}